import { render, staticRenderFns } from "./CohortRowCards.vue?vue&type=template&id=a9c79f5a"
import script from "./CohortRowCards.vue?vue&type=script&lang=js"
export * from "./CohortRowCards.vue?vue&type=script&lang=js"
import style0 from "./CohortRowCards.vue?vue&type=style&index=0&id=a9c79f5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports